import { Injectable } from '@angular/core';
import { DoctorFacade } from '@modules/doctor/doctor.facade';
import { DoctorQuery } from '@modules/doctor/state/doctor-query';
import { DoctorStore } from '@modules/doctor/state/doctor-store';
import { LoggerService } from '@core/services/logger/logger.service';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { ShellStore } from '@shared/store/shell/shell-store';

/**
 * Facade for the rx-intuitive doctor license UI. Extends DoctorFacade and overrides
 * updateLicense to also sync the license to DoctorStore and set isLicenseEditable.
 */
@Injectable()
export class RxIntuitiveDoctorLicenseFacade extends DoctorFacade {
	constructor(store: DoctorStore, query: DoctorQuery, shellStore: ShellStore, shellQuery: ShellQuery, logger: LoggerService) {
		super(store, query, shellStore, shellQuery, logger);
	}

	override updateLicense({ license }: { license: string }): void {
		super.updateLicense({ license });

		const current = this.store.getValue().doctor;

		if (current) {
			this.store.update({ doctor: { ...current, Licence: license || '' } });
		}

		if (license) {
			this.store.update({ isLicenseEditable: false });
		}
	}
}
